import { Grid } from "@material-ui/core";
import React, { FunctionComponent } from "react";

export const AppLayoutHeader: FunctionComponent = ({ children }) => (
  <Grid item xs={10}>
    {children}
  </Grid>
);
